module.exports = __webpack_public_path__ + "img/avatar5.4f03a127.png";